var _excluded = ["isActive", "element", "text", "className", "hasIcon", "renderResponsive"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, bool, oneOfType, func, object } from 'prop-types';
import classNames from 'classnames';
import TextLink from '../TextLink/TextLink';
import Icon from '../Icon/Icon';
import { ArrowLeftIcon, ChevronRightIcon } from '@ruter-ds/rds-icons';
var propTypes = {
  /** The type of element you need. `a` or `Link` (from react router) are the most common.
   *
   * Example usage with React Router:<br>
   * `<BreadcrumbsItem element={Link} to="/somepage" />` */
  element: oneOfType([string, func, object]),

  /** Breadcrumb text. */
  text: string,

  /** If you want an item to render as a span instead of a link.
   * Example usage is the current page, i.e. last item in the list. */
  isActive: bool,

  /** The last item should not have an icon. */
  hasIcon: bool,

  /** Responsive behaviour. This prop is also managed by the same prop in the `<Breadcrumbs/>` component. */
  renderResponsive: bool,

  /** Add your own custom class names to the component. */
  className: string
};
var defaultProps = {
  isActive: false,
  element: 'a',
  hasIcon: true,
  renderResponsive: false
};
/**
 * A child of the Breadcrumbs component that indicates to the users where they are.
 * @visibleName Breadcrumbs Item
 */

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var isActive = _ref.isActive,
      element = _ref.element,
      text = _ref.text,
      className = _ref.className,
      hasIcon = _ref.hasIcon,
      renderResponsive = _ref.renderResponsive,
      rest = _objectWithoutProperties(_ref, _excluded);

  var breadcrumbLabel = isActive ? /*#__PURE__*/React.createElement("span", _extends({
    className: 'rds-breadcrumbs__label'
  }, rest), renderResponsive ? /*#__PURE__*/React.createElement(Icon, {
    component: /*#__PURE__*/React.createElement(ArrowLeftIcon, null),
    size: "small",
    className: "rds-breadcrumbs__back-link"
  }) : text) : /*#__PURE__*/React.createElement(TextLink, _extends({
    element: element,
    className: 'rds-breadcrumbs__label'
  }, rest), renderResponsive ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "rds-is-vishidden"
  }, " ", text), /*#__PURE__*/React.createElement(Icon, {
    component: /*#__PURE__*/React.createElement(ArrowLeftIcon, null),
    size: "small",
    className: "rds-breadcrumbs__back-link"
  })) : text);
  var componentClassNames = classNames('rds-breadcrumbs__item', {
    'rds-breadcrumbs__item--is-active': isActive
  }, className);
  return /*#__PURE__*/React.createElement("li", {
    className: componentClassNames
  }, breadcrumbLabel, hasIcon && /*#__PURE__*/React.createElement(Icon, {
    component: /*#__PURE__*/React.createElement(ChevronRightIcon, null),
    size: "small",
    className: "rds-breadcrumbs__icon"
  }));
};

BreadcrumbsItem.propTypes = propTypes;
BreadcrumbsItem.defaultProps = defaultProps;
export default BreadcrumbsItem;